"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.File = exports.Blob = exports.FormData = void 0;
const globalObject = (function () {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return window;
}());
exports.FormData = globalObject.FormData, exports.Blob = globalObject.Blob, exports.File = globalObject.File;



//////////////////
// WEBPACK FOOTER
// ./node_modules/formdata-node/lib/cjs/browser.js
// module id = +lfa
// module chunks = 0